// extracted by mini-css-extract-plugin
export default {"lds_ellipsis":"Loader_lds_ellipsis__Ues+L","lds_ellipsis1":"Loader_lds_ellipsis1__pnaJ-","lds_ellipsis2":"Loader_lds_ellipsis2__Rb1Th","lds_ellipsis3":"Loader_lds_ellipsis3__J7TsV"};